













import { Vue, Component, Prop } from 'vue-property-decorator'
import SearchResultsList from 'components/presenter/search/SearchResultsList.vue'

@Component({
  components: {
    SearchResultsList
  }
})
export default class PresenterSearchResults extends Vue {

  @Prop()
  readonly loading!: boolean

  @Prop()
  readonly query!: string

  @Prop()
  readonly found!: []
}
